export default class Map {

	constructor() {

		this.settings = {
			$map: $('#map')
		};

		this.bindUIActions();

	}

	bindUIActions() {

		if (this.settings.$map.length) {
			// This pulls from the latitude and logitude that has been set in the ACF field - ensure this is set correctly
			const latitude = document.querySelector('#lat');
			const longitude = document.querySelector('#long');

			if (latitude && longitude) {
				const lat = latitude.dataset.latitude;
				const lng = longitude.dataset.longitude;
				
				// Map styling can be done here - e.g. create a mapStyles object, and then include it in the myOptions object which is what the map is created using

				let myOptions = {
					center: new google.maps.LatLng(lat, lng),
					zoom: 12,
					mapTypeId: google.maps.MapTypeId.hybrid,
					disableDefaultUI: true,
				};

				const map = new google.maps.Map(document.getElementById('map'), myOptions);

				// Uses the src from the image file that is set in ACF
				const pin = document.getElementById('map-pin').src;

				const marker = new google.maps.Marker({
					position: {
						lat: parseFloat(lat),
						lng: parseFloat(lng)
					},
					map: map,
					opacity: 1.0,
					icon: pin
				});
			}
		}


	}
}

new Map();